import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import ServiceBanner from '../sections/ServiceBanner/ServiceBanner';


const Services = () => {


  return (
    <>
      <Navbar />
      <ServiceBanner/>
      <Footer />
    </>
  );
};

export default Services;


